import styled from 'styled-components';

export const BaseInput = styled.input`
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  color: #25282b !important;
  margin: 0 !important;
  border-radius: 8px !important;
  padding: 11px 16px !important;
  border: 1px solid #dbdde0 !important;

  ::placeholder {
    color: #cacccf !important;
  }
`;

export const Label = styled.label`
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #52575c;
  text-align: left;
`;
